module.exports = __webpack_public_path__ + "static/media/agio.eeed677c.svg";